import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
import { DEFAULT_LOCALE } from './types';
const LocaleContext = createContext({
    locale: DEFAULT_LOCALE,
    setLocale: () => { },
});
export function LocaleProvider({ initialLocale = DEFAULT_LOCALE, children }) {
    const [locale, setLocale] = useState(initialLocale);
    const value = useMemo(() => ({ locale, setLocale }), [locale]);
    return _jsx(LocaleContext.Provider, { value: value, children: children });
}
export function useLocale() {
    return useContext(LocaleContext);
}
